import { render, staticRenderFns } from "./IconNewEstablishment.vue?vue&type=template&id=299d06e0"
import script from "./IconNewEstablishment.vue?vue&type=script&lang=js"
export * from "./IconNewEstablishment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports